export default __webpack_public_path__ + "static/media/stokerverse-rpg-companion.ea189e40.png";